<div class="panel panel-form" [ngClass]="{ open: open }">
  <lib-form-header [open]="open" [header]="header" [required]="required" (openChange)="open = $event"></lib-form-header>
  @if (open && form) {
    <div class="panel-content">
      <form [formGroup]="form">
        <div class="row">
          @for (key of order; track key) {
            <div class="col-12 col-sm-6 form-field-container align-self-end">
              @if (key !== 'address_visible') {
                <div class="form-field-label" [ngClass]="{ required: isFormControlRequired(getFormControl(key)) }">
                  {{ 'form.field.' + key | transloco }}
                </div>
              }
              @if (key !== 'country' && key !== 'address_visible') {
                <mat-form-field class="form-field" [floatLabel]="'auto'">
                  <input matInput [formControlName]="key" [required]="isFormControlRequired(getFormControl(key))" />
                  @if (getFormControl(key).invalid) {
                    <mat-error>
                      @if (getFormControl(key).errors.required) {
                        {{ 'form.error.required' | transloco }}
                      }
                    </mat-error>
                  }
                </mat-form-field>
              }
              @if (key === 'country') {
                <lib-select
                  [options]="countries"
                  [value]="getFormControl(key).value"
                  [errors]="getFormControl(key).errors"
                  (valueChange)="countryValueChange($event)"
                ></lib-select>
              }
            </div>
          }
        </div>
      </form>
    </div>
  }
</div>
